import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ProductApplication = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 40 40">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#F5E4E7"/>
      <g clipPath="url(#clip0_16014_102280)">
      <path d="M20 10.8333V29.1666" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M24.1667 14.1667H17.9167C17.1431 14.1667 16.4013 14.474 15.8543 15.021C15.3073 15.5679 15 16.3098 15 17.0834C15 17.8569 15.3073 18.5988 15.8543 19.1457C16.4013 19.6927 17.1431 20 17.9167 20H22.0833C22.8569 20 23.5987 20.3073 24.1457 20.8543C24.6927 21.4013 25 22.1431 25 22.9167C25 23.6902 24.6927 24.4321 24.1457 24.9791C23.5987 25.5261 22.8569 25.8334 22.0833 25.8334H15" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_16014_102280">
      <rect width="20" height="20" fill="white" transform="translate(10 10)"/>
      </clipPath>
      </defs>
      </svg>
    </SvgIcon>
  );
}

export default ProductApplication;



